module.exports = __webpack_public_path__ + "img/red_053.9a6b8623.png";